<template>
  <PanelItem :index="index" :field="field">
    <template #value>
      <p dir="ltr" class="text-left">{{ field.value }}</p>
    </template>
  </PanelItem>
</template>

<script>
export default {
  props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],
}
</script>
